import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import enums from 'util/enums';

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: ['Location']
});

export const locationApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    enumerateLocations: build.query({
      async queryFn(args) {
        const {
          skip = 0,
          keyword = '',
          sortKey = 'Created',
          sortOrderAsc = false,
          pageSize = 25
        } = args || {};

        const trimmedKeyword = (keyword || '').trim();
        const effectiveSortKey = sortKey === 'IsFavorite' ? 'Created' : sortKey;
        const orderDirection = sortOrderAsc ? 'asc' : 'desc';

        const body = {
          MaxResults: pageSize,
          Skip: skip,
          OrderBy: effectiveSortKey,
          OrderDirection: orderDirection,
          IncludeData: false,
          IncludeSubordinates: false,
          ...(trimmedKeyword.length > 0 && { Text: trimmedKeyword }),
          Filters: {
            ...(sortKey === 'IsFavorite' && { IsFavorite: 1 })
          }
        };

        try {
          const res = await api.Enumeration(
            enums.ENUMERATION_TYPES.LOCATION,
            body
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      keepUnusedDataFor: 60,
      providesTags: [{ type: 'Location', id: 'LIST' }]
    }),

    addSavedLocation: build.mutation({
      async queryFn(args) {
        try {
          const { displayName, address1, address2, city, state, postalCode } =
            args || {};
          const res = await api.SavedLocations.add(
            displayName,
            address1,
            address2,
            city,
            state,
            postalCode
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'Location', id: 'LIST' }]
    }),

    updateSavedLocation: build.mutation({
      async queryFn(args) {
        try {
          const {
            guid,
            displayName,
            address1,
            address2,
            city,
            state,
            postalCode
          } = args || {};
          const res = await api.SavedLocations.update(
            guid,
            displayName,
            address1,
            address2,
            city,
            state,
            postalCode
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'Location', id: 'LIST' }]
    }),

    removeSavedLocation: build.mutation({
      async queryFn(guid) {
        try {
          const res = await api.SavedLocations.remove(guid);
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'Location', id: 'LIST' }]
    })
  })
});

export const {
  useEnumerateLocationsQuery,
  useAddSavedLocationMutation,
  useUpdateSavedLocationMutation,
  useRemoveSavedLocationMutation
} = locationApi;
